import { render, staticRenderFns } from "./DataExportModal.vue?vue&type=template&id=39418d9a&scoped=true&"
import script from "./DataExportModal.vue?vue&type=script&lang=js&"
export * from "./DataExportModal.vue?vue&type=script&lang=js&"
import style0 from "./DataExportModal.vue?vue&type=style&index=0&id=39418d9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39418d9a",
  null
  
)

export default component.exports